// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"d94bc6b0","232":"5cc666f9","235":"e416252d","404":"5ab4552b","800":"95deb9a2","922":"9516609b"}[chunkId] + ".chunk.js";
};